import request from '@/utils/request'

/**
 * 待完成学习
 */
export function getUserStudyTask(data) {
  return request({
    url: 'api/getUserStudyTask',
    method: 'post',
    params: data
  })
}

/**
 * 获取公告
 */
export function getNoticeList(data) {
  return request({
    url: 'api/getNotice',
    method: 'post',
    params: data
  })
}

/**
 * 用户学习记录
 */
export function getUserStudyList(data) {
  return request({
    url: 'api/getUserStudyList',
    method: 'post',
    params: data
  })
}

/**
 * 学习主页Banner
 */
export function getStudyBanner(data) {
  return request({
    url: 'api/getStudyBanner',
    method: 'post',
    params: data
  })
}

/**
 * 获取资讯
 */
export function getNews(data) {
  return request({
    url: 'api/getNews',
    method: 'post',
    params: data
  })
}

/**
 * 用户签到详情
 */
export function getUserCheckDetail(data) {
  return request({
    url: 'api/getUserCheckDetail',
    method: 'post',
    params: data
  })
}

/**
 * 用户签到
 */
export function userCheckIn(data) {
  return request({
    url: 'api/userCheckIn',
    method: 'post',
    params: data
  })
}

/**
 * 资讯详情
 */
export function getNewsDetail(data) {
  return request({
    url: 'api/getNewsDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取资讯PC分页
 */
export function getNewsPC(data) {
  return request({
    url: 'api/getNewsPC',
    method: 'post',
    params: data
  })
}

/**
 * 获取公告详情
 */
export function getNoticeDetail(data) {
  return request({
    url: 'api/getNoticeDetail',
    method: 'post',
    params: data
  })
}

/**
 * 获取公告分类
 */
export function getNoticeCategory() {
  return request({
    url: 'api/getNoticeCategory',
    method: 'get'
  })
}

/**
 * 用户学习缓存
 * @param data
 */
export function addUserStudyRecord(data) {
  return request({
    url: 'api/addUserStudyRecord',
    method: 'post',
    params: data
  })
}

/**
 * 获取用户首页待办事项
 * @param data
 */
export function getUserTodoList(data) {
  return request({
    url: 'api/getUserTodoList',
    method: 'post',
    params: data
  })
}

